import React from 'react'
import { Input, Button, Modal, Form } from 'antd'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import { useQuery } from '@tanstack/react-query'

import { profileOptions } from 'utils/constants'
import { errorMessage } from 'services/messager'
import { getCompanyTeams } from 'services/demands/teamsServices'

var groupSelect = null

const NewUserModal = ({
	handleCreate,
	handleCancel,
	handleNewUser,
	newUser,
	showModal,
	groups,
}) => {
	const [form] = Form.useForm()
	const { data: teams, isLoading: isLoadingTeams } = useQuery({
		queryKey: ['team-options'],
		queryFn: fetchTeams,
		staleTime: 1000 * 30,
		refetchOnWindowFocus: false,
		retry: false,
	})

	async function fetchTeams() {
		try {
			const { list: teams } = await getCompanyTeams(1, 100)

			return teams
		} catch (error) {
			console.log(error)
			errorMessage({
				content: 'Erro ao carregar times',
			})
		}
	}

	const getSelectOptions = (options) => {
		if (!options) return <></>

		return (
			<>
				{options.map((option) => (
					<Select.Option
						key={`newusermodal-${option.id}-${option.name}`}
						value={option.id}>
						{option.name}
					</Select.Option>
				))}
			</>
		)
	}

	return (
		<Modal
			open={showModal}
			onCancel={handleCancel}
			footer={[
				<Button key="cancelar" onClick={handleCancel}>
					Cancelar
				</Button>,
				<Button
					key="criar"
					onClick={() => handleCreate(form)}
					form="newUserForm"
					disabled={!(newUser.name && newUser.email)}>
					Criar
				</Button>,
			]}>
			<Form form={form} id="newUserForm" onChange={() => handleNewUser(form)}>
				<Form.Item label="Novo Usuário"></Form.Item>
				<Form.Item label="Nome" name="name">
					<Input value={newUser.name} />
				</Form.Item>
				<Form.Item label="Email" name="email">
					<Input />
				</Form.Item>
				<Form.Item label="Grupos" name="groups">
					<Select
						ref={(select) => (groupSelect = select)}
						mode="multiple"
						allowClear
						style={{ width: '100%' }}
						placeholder="Selecione o grupo"
						onChange={() => handleNewUser(form)}
						onSelect={() => groupSelect.blur()}
						onDeselect={() => groupSelect.blur()}>
						{getSelectOptions(groups)}
					</Select>
				</Form.Item>
				<Form.Item label="Perfil" name="perfil">
					<Select
						style={{ width: '100%' }}
						placeholder="Selecione o perfil"
						onChange={() => {
							handleNewUser(form)
						}}>
						{getSelectOptions(profileOptions)}
					</Select>
				</Form.Item>
				<Form.Item label="Times" name="teams">
					<Select
						mode="multiple"
						allowClear
						style={{ width: '100%' }}
						placeholder="Selecione os times"
						onChange={() => {
							handleNewUser(form)
						}}
						loading={isLoadingTeams}>
						{!isLoadingTeams && getSelectOptions(teams)}
					</Select>
				</Form.Item>
			</Form>
		</Modal>
	)
}

NewUserModal.propTypes = {
	handleCreate: PropTypes.func,
	handleCancel: PropTypes.func,
	handleNewUser: PropTypes.func,
	newUser: PropTypes.object,
	showModal: PropTypes.bool,
	groups: PropTypes.array,
}

NewUserModal.defaultProps = {
	groups: [],
}

export default NewUserModal
